import { __rest, __read, __assign } from '../node_modules/tslib/tslib.es6.esm.js';
import React__default, { forwardRef, useState } from 'react';
import IconClose from '../assets/icons/IconClose.esm.js';
import SearchRegular from '../assets/icons/SearchRegular.esm.js';
import SpinnerCircle from '../assets/icons/SpinnerCircle.esm.js';
import classNames from 'classnames';
import NvInput from '../NvInput/NvInput.esm.js';

var NvInputSearch = forwardRef(function (_a, ref) {
    var label = _a.label, onChangeInput = _a.onChangeInput, placeholder = _a.placeholder, showPrefixElement = _a.showPrefixElement, classNames$1 = _a.classNames, isLoading = _a.isLoading, onSearch = _a.onSearch, buttonResetAriaLabel = _a.buttonResetAriaLabel, buttonSubmitAriaLabel = _a.buttonSubmitAriaLabel, onClearInput = _a.onClearInput, _b = _a.defaultValue, defaultValue = _b === void 0 ? '' : _b, props = __rest(_a, ["label", "onChangeInput", "placeholder", "showPrefixElement", "classNames", "isLoading", "onSearch", "buttonResetAriaLabel", "buttonSubmitAriaLabel", "onClearInput", "defaultValue"]);
    var _c = __read(useState(defaultValue), 2), searchTerm = _c[0], setSearchTerm = _c[1];
    var onClear = function () {
        setSearchTerm('');
        onClearInput === null || onClearInput === void 0 ? void 0 : onClearInput();
    };
    var onChange = function (event) {
        var value = event.target.value;
        setSearchTerm(value);
        onChangeInput === null || onChangeInput === void 0 ? void 0 : onChangeInput(value);
    };
    var onKeyDown = function (event) {
        if (event.key === 'Enter') {
            onSearch === null || onSearch === void 0 ? void 0 : onSearch(searchTerm);
        }
        if (event.key === 'Escape' && searchTerm) {
            onClear();
        }
    };
    return (React__default.createElement(NvInput, __assign({}, props, { classes: { root: classNames('nv-input-search', classNames$1) }, hideLabel: true, label: label, onChange: onChange, onKeyDown: onKeyDown, placeholder: placeholder, prefixAction: function () { return onSearch === null || onSearch === void 0 ? void 0 : onSearch(searchTerm); }, prefixElement: showPrefixElement && React__default.createElement(SearchRegular, { ariaLabel: buttonSubmitAriaLabel }), ref: ref, suffixAction: isLoading ? undefined : onClear, suffixElement: React__default.createElement(React__default.Fragment, null,
            isLoading && (React__default.createElement(SpinnerCircle, { "aria-label": "Loading icon", "data-testid": "loading-icon", size: "large", theme: "primary" })),
            searchTerm && !isLoading && React__default.createElement(IconClose, { ariaLabel: buttonResetAriaLabel })), value: searchTerm })));
});
NvInputSearch.displayName = 'NvInputSearch';

export { NvInputSearch as default };
//# sourceMappingURL=NvInputSearch.esm.js.map
